/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var trigger_category_changes = document.querySelectorAll('.js-category');
  if(trigger_category_changes) {
    trigger_category_changes.forEach((trigger_category_change) => {
      trigger_category_change.addEventListener('change', (e) => {
        e.preventDefault();

        var category_base = trigger_category_change.getAttribute('data-category-base');

        if(category_base === '') {
          category_base = 'category';
        }

        if(trigger_category_change.querySelector('select').value === '0') {
          location.href = trigger_category_change.getAttribute('data-url-prefix');

          return;
        }

        location.href = trigger_category_change.getAttribute('data-url-prefix') + '/' + category_base + '/' + trigger_category_change.querySelector('select').value;
      });
    });
  }

  var trigger_form_submits = document.querySelectorAll('.js-search-submit');
  if(trigger_form_submits) {
    trigger_form_submits.forEach((trigger_form_submit) => {
      trigger_form_submit.addEventListener('submit', (e) => {
        e.preventDefault();

        var query_base = trigger_form_submit.getAttribute('data-category-base');

        if(query_base === '') {
          query_base = 'search';
        }

        if(trigger_form_submit.querySelector('input').value === '') {
          location.href = trigger_form_submit.getAttribute('data-url-prefix');
          return false;
        }

        console.log(trigger_form_submit.querySelector('input').value);

        location.href = trigger_form_submit.getAttribute('data-url-prefix') + '/' + query_base + '/' + encodeURIComponent(trigger_form_submit.querySelector('input').value) + '/';
        return false;
      });
    });
  }
}());